import { getFlagsWithRemote, parseFlagValue } from 'Utils/features';
import { FEATURE } from 'Services/Logger';
import { consumerEnablementBff } from 'Utils/httpClients';

import AbstractFeatureFlagProvider from './AbstractFeatureFlagProvider';

class RemoteConsumerEnablementProvider extends AbstractFeatureFlagProvider {
  constructor(priority, logger) {
    super('CONSUMER_ENABLEMENT_FF', priority, true);
    this.logger = logger;
  }

  async getFeatureFlags() {
    try {
      const flagsWithRemote = getFlagsWithRemote();
      const getUserFeatureFlagsResponse = await consumerEnablementBff.getUserFeatureFlags();
      const featureFlags = getUserFeatureFlagsResponse.features ?? {};

      Object
        .entries(featureFlags)
        .forEach(([key, value]) => {
          const featureFlagKey = flagsWithRemote[key];
          const featureFlagValue = parseFlagValue(value);
          if (featureFlagKey) {
            this.features.set(featureFlagKey, featureFlagValue);
          }
        });
    } catch (error) {
      if (!this.logger) throw error;

      this.logger.error(
        'Error fetching or parsing remote feature flags',
        `${FEATURE.FEATURE_FLAGS}.RemoteConsumerEnablementProvider.getFeatureFlags`,
        { error },
      );
    }
  }
}

export default RemoteConsumerEnablementProvider;
